import { render, staticRenderFns } from "./activeTeacherStatis.vue?vue&type=template&id=2db19222&scoped=true"
import script from "./activeTeacherStatis.vue?vue&type=script&lang=js"
export * from "./activeTeacherStatis.vue?vue&type=script&lang=js"
import style0 from "./activeTeacherStatis.vue?vue&type=style&index=0&id=2db19222&prod&lang=scss&scoped=true"
import style1 from "./activeTeacherStatis.vue?vue&type=style&index=1&id=2db19222&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db19222",
  null
  
)

export default component.exports